<div class="range_container d-flex flex-column pt-2">
  <div
    class="sliders_control d-flex flex-column position-relative"
    style="height: 36px"
  >
    <div id="fromSliderTooltip" class="slider-tooltip">115</div>
    <input
      [disabled]="disabled"
      id="fromSlider"
      type="range"
      value="25"
      min="0"
      max="100"
      steps="1"
    />
    <div id="toSliderTooltip" class="slider-tooltip">120</div>
    <input
      [disabled]="disabled"
      id="toSlider"
      type="range"
      value="75"
      min="0"
      max="100"
      steps="1"
      style="top: 4px"
    />
  </div>
  <div
    id="scale"
    class="d-flex justify-content-between text-muted"
    data-steps="50"
  ></div>
</div>
